import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import RichText from '@/app/components/RichText';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';

const MembershipBetterSleep = () => {
  const t = useTranslations();
  const pathname = usePathname();

  return (
    <LayoutGrid data-cy="membership-better-sleep">
      <GridItem
        colStart={{ sm: 'full', lg: 'full' }}
        colEnd={{ sm: 'full', lg: 'full' }}
        className="relative"
      >
        <div className="relative aspect-3200/1111 w-full">
          <ArtDirectionImage
            srcSet={[
              {
                src: 'membership/membership-buy-cta-hero-mobile',
                media: '(max-width: 767px)',
              },
              {
                src: 'membership/membership-buy-cta-hero',
                media: '(min-width: 768px)',
              },
            ]}
            localizedAlt="membership_better_sleep_alt"
            sizes="100vw"
            fill
            className="object-cover"
          />
          <div className="relative mx-6 max-w-[1158px] xl:mx-auto">
            <div className="pt-20 pb-[410px] md:max-w-sm md:py-40 lg:max-w-md lg:py-48 xl:max-w-xl">
              <Typography
                variant="h2"
                Element="h2"
                className="text-4xl text-sandstone-100 md:text-6xl"
                data-cy="better_sleep_banner_title"
              >
                <RichText messageKey="better_sleep_banner_title" />
              </Typography>
              <Link
                href={STORE_POP_PATHNAME}
                onClick={async () => {
                  await window.ouraAnalytics.track(EventType.CTAClicked, {
                    cta: 'Buy Oura Ring',
                    location: 'Better Sleep Banner',
                    path: pathname,
                  });
                }}
                passHref
              >
                <Button
                  variant="primary"
                  className="mt-6"
                  data-cy="better_sleep_banner_cta"
                >
                  {t('better_sleep_banner_cta')}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </GridItem>
    </LayoutGrid>
  );
};

export default MembershipBetterSleep;
